import { Link } from "gatsby"
import React, { useEffect, useState } from "react"

import "./anchors-link.scss"
export default function AnchorsLinks({ anchors = [], activeOption = null, setActiveOption  }) {
  return (
    <div className="f-embajadoras-anchors-links">
      <div className="f-embajadoras-anchors-links__container">
        {anchors.map((anchor, index) => (
          <Link
            key={index}
            activeClassName="active"
            key={anchor.ref}
            className={`f-embajadoras-anchors-links__item ` + (activeOption !== null && activeOption === index ? 'active' : '') + (anchor.active === false ? " disabled " : " ")}
            to={anchor.ref}
            onClick={(e) => {
              e.preventDefault()
              if (activeOption !== null) {
                setActiveOption(index)
              } else {
                window.location.href = anchor.ref
              }
            }}
          >
            {anchor.label}
          </Link>
        ))}
      </div>
    </div>
  )
}
